<template>
  <a-tooltip>
    <template #title>
      <slot></slot>
    </template>
    <button
        :data-dusk="dataDusk"
        :class="{'more-than-one': hasMoreThanOne}"
        @click="$emit('click', $event)"
        class="list-button"
    >
      <span class="attachable-count" v-if="hasMoreThanOne">{{count}}</span>
      <slot name="icon">
        <i v-if="icon" class="fallback-icon" :class="icon"></i>
      </slot>
    </button>
  </a-tooltip>

</template>

<script>
export default {
  name: "ListButton.vue",
  emits: ['click'],
  props: {
    dataDusk: String,
    icon: {
      required: false,
      type: String,
    },
    count: {
      type: Number,
      required: false,
      default: 0,
    }
  },
  computed: {
    hasMoreThanOne() {
      return this.count > 0;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/_default.scss";
.list-button {
  background-color: $main-content-bg-color;
  border-radius: $border-radius-large;
  color: $brand-primary;
  //border: 1px solid $brand-primary;
  box-shadow: $shadow-xs;
  border: none;
  height: 30px;
  width: 30px;
  display: flex;
  align-items: center;
  justify-content: center;

  span svg {
    bottom: 0;
  }
}
.more-than-one {

  box-shadow: $shadow-md;
  position: relative;
  i {
    color: white;
  }
  .attachable-count {
    position: absolute;
    display: flex;
    justify-content: center;
    align-items:center;
    right: -8px;
    top: -8px;
    font-size: 13px;
    background-color: $brand-danger;
    color: white;
    border-radius: 9999px;
    height: $font-size-large;
    padding-right: $spacing-xxs;
    padding-left: $spacing-xxs;
  }
}
</style>
